export default __webpack_public_path__ + "static/pulse_customer_greeting_2-f5eefefe0691affc32c86836a7c96d19.jpeg";